import isEmpty from 'lodash/isEmpty'
import isString from 'lodash/isString'

const CONTROL_CHARACTER_MAX_CODE = 0x001f
const DELETE_CHARACTER_CODE = 0x007f

const includesControlCharacter = value =>
  [...value].some(character => {
    const characterCode = character.charCodeAt(0)
    return (
      characterCode <= CONTROL_CHARACTER_MAX_CODE ||
      characterCode === DELETE_CHARACTER_CODE
    )
  })

export const isSafeRedirect = redirectTo => {
  if (!isString(redirectTo) || isEmpty(redirectTo)) return false

  return (
    redirectTo.startsWith('/') &&
    !redirectTo.startsWith('//') &&
    !redirectTo.includes('\\') &&
    !includesControlCharacter(redirectTo)
  )
}
